import { Routes } from '@angular/router';
import { Layout } from './core/layout/layout';
import { adminGuard } from './core/guards/admin.guard';
import { authGuard } from './core/guards/auth.guard';
import { tierFeatureGuard } from './core/guards/tier-feature.guard';

export const routes: Routes = [
  {
    path: '',
    component: Layout,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/landing/landing').then((m) => m.Landing),
      },
    ],
  },
  {
    path: 'dashboard',
    loadComponent: () =>
      import('./pages/dashboard/dashboard-shell/dashboard-shell').then(
        (m) => m.DashboardShell,
      ),
    canActivate: [authGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/dashboard/dashboard').then((m) => m.Dashboard),
      },
      {
        path: 'analysis',
        loadComponent: () =>
          import('./pages/dashboard/components/my-analysis/my-analysis').then(
            (m) => m.MyAnalysis,
          ),
      },
      {
        path: 'settings',
        loadComponent: () =>
          import('./pages/dashboard/components/settings-section/settings-section').then(
            (m) => m.SettingsSection,
          ),
      },
      {
        path: 'billing',
        loadComponent: () =>
          import('./pages/dashboard/components/billing-section/billing-section').then(
            (m) => m.BillingSection,
          ),
      },
      {
        path: 'seven-day-plan',
        canActivate: [tierFeatureGuard('sevenDayPlan')],
        loadComponent: () =>
          import('./pages/dashboard/components/seven-day-plan/seven-day-plan').then(
            (m) => m.SevenDayPlan,
          ),
      },
      {
        path: 'job-tracker',
        canActivate: [tierFeatureGuard('jobTracker')],
        loadComponent: () =>
          import('./pages/dashboard/components/job-tracker/job-tracker').then(
            (m) => m.JobTracker,
          ),
      },
      {
        path: 'linkedin',
        canActivate: [tierFeatureGuard('linkedin')],
        loadComponent: () =>
          import('./pages/dashboard/components/linkedin-section/linkedin-section').then(
            (m) => m.LinkedInSection,
          ),
      },
      {
        path: 'interview-prep',
        canActivate: [tierFeatureGuard('interviewPrep')],
        loadComponent: () =>
          import(
            './pages/dashboard/components/interview-prep-section/interview-prep-section'
          ).then((m) => m.InterviewPrepSection),
      },
      {
        path: 'outreach',
        canActivate: [tierFeatureGuard('outreach')],
        loadComponent: () =>
          import('./pages/dashboard/components/outreach-section/outreach-section').then(
            (m) => m.OutreachSection,
          ),
      },
      {
        path: 'cvs',
        loadComponent: () =>
          import('./pages/dashboard/components/cv-detail/cv-detail').then((m) => m.CvDetail),
      },
      {
        path: 'job-descriptions',
        loadComponent: () =>
          import('./pages/dashboard/components/jd-section/jd-section').then(
            (m) => m.JdSection,
          ),
      },
      {
        path: 'cv-rewrites',
        loadComponent: () =>
          import('./pages/dashboard/components/cv-rewrite-section/cv-rewrite-section').then(
            (m) => m.CvRewriteSection,
          ),
      },
      {
        path: 'reality-check',
        loadComponent: () =>
          import(
            './pages/dashboard/components/reality-check-section/reality-check-section'
          ).then((m) => m.RealityCheckSection),
      },
      {
        path: 'reality-check/:id',
        loadComponent: () =>
          import(
            './pages/dashboard/components/reality-check-detail/reality-check-detail'
          ).then((m) => m.RealityCheckDetail),
      },
      {
        path: 'job-matches',
        loadComponent: () =>
          import('./pages/dashboard/components/job-matches-section/job-matches-section').then(
            (m) => m.JobMatchesSection,
          ),
      },
    ],
  },
  {
    path: 'admin',
    loadComponent: () =>
      import('./pages/admin/admin-shell/admin-shell').then((m) => m.AdminShell),
    canActivate: [authGuard, adminGuard],
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'users' },
      {
        path: 'users',
        loadComponent: () =>
          import('./pages/admin/components/admin-users/admin-users').then((m) => m.AdminUsers),
      },
      {
        path: 'users/:id',
        loadComponent: () =>
          import('./pages/admin/components/admin-user-detail/admin-user-detail').then(
            (m) => m.AdminUserDetail,
          ),
      },
      {
        path: 'metrics',
        loadComponent: () =>
          import('./pages/admin/components/admin-metrics/admin-metrics').then(
            (m) => m.AdminMetrics,
          ),
      },
      {
        path: 'payments',
        loadComponent: () =>
          import('./pages/admin/components/admin-payments/admin-payments').then(
            (m) => m.AdminPayments,
          ),
      },
    ],
  },
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login').then((m) => m.Login),
  },
  {
    path: 'register',
    loadComponent: () => import('./pages/register/register').then((m) => m.Register),
  },
  {
    path: 'checkout',
    loadComponent: () => import('./pages/checkout/checkout').then((m) => m.Checkout),
  },
];
